<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  title: string;
  text: string;
  step: number;
  totalSteps: number;
  posX: number;
  posY: number;
  // ✅ Nova prop para controlar a posição da seta
  placement?: 'right' | 'bottom';
}
const props = withDefaults(defineProps<Props>(), {
    // Por padrão, a seta aponta para a esquerda (ficando à direita do alvo)
    placement: 'right',
});

const emit = defineEmits(['next', 'finish']);

const isLastStep = computed(() => props.step === props.totalSteps - 1);

const tipStyle = computed(() => ({
  top: `${props.posY}px`,
  left: `${props.posX}px`,
}));

const handleCloseOrNext = () => {
    if (isLastStep.value) {
        emit('finish');
    } else {
        emit('next');
    }
};
</script>

<template>
  <div
    class="fixed z-[9999] w-[90vw] max-w-sm sm:w-80 md:w-96 rounded-lg bg-white p-4 text-gray-800 shadow-2xl border-2 border-primary-500"
    :style="tipStyle"
    data-onboarding-tip="true"
  >
    <div
      v-if="props.placement === 'right'"
      class="absolute -left-2 top-1/2 -translate-y-1/2 h-4 w-4 rotate-45 border-primary-500 border-l-2 border-b-2  bg-white"
    ></div>

    <div
      v-if="props.placement === 'bottom'"
      class="absolute -top-2 left-1/2 -translate-x-1/2 h-4 w-4 rotate-45 border-primary-500 border-l-2 border-t-2  bg-white"
    ></div>

      <button
        @click="handleCloseOrNext"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition-colors"
        aria-label="Fechar dica"
    >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
    </button>

      <h3 class="text-lg font-bold mb-2 pr-6">{{ props.title }}</h3>

    <p class="mb-4 text-sm">{{ text }}</p>

    <div class="flex items-center justify-between">
      <span class="text-xs text-gray-600">Passo {{ step + 1 }} de {{ totalSteps }}</span>
      <div>
        <button v-if="!isLastStep" @click="emit('next')" class="rounded bg-blue-600 px-3 py-1 text-xs font-semibold text-white">
          Próximo
        </button>
        <button v-else @click="emit('finish')" class="rounded bg-green-600 px-3 py-1 text-xs font-semibold text-white">
          Começar
        </button>
      </div>
    </div>
  </div>
</template>
